import { Component, OnInit } from "@angular/core";
import { WidgetService } from "../../services/widget.service";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { WIDGET_ID } from "../../utils/constant";
import {
  HttpClient,
  HttpResponse,
  HttpHeaders,
  HttpErrorResponse,
  HttpParams,
  HttpRequest,
  HttpEvent,
  HttpEventType,
} from "@angular/common/http";

declare const Calendly;
class Result {
  score: number;
  grade: string;
  points: Array<string> = [];
  videoURL: string = "";
}

@Component({
  selector: "app-final-result",
  templateUrl: "./final-result.component.html",
  styleUrls: ["./final-result.component.scss"],
})
export class FinalResultComponent implements OnInit {
  result: Result = new Result();
  calendlyWidgetHTML = `<div class="calendly-inline-widget row" data-url="https://calendly.com/shaiban/apeiron-health-assessment"
  style="min-width:320px;height:630px;"></div><script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js"></script>`;
  widgetHtml: SafeHtml;
  predata = {
    createdAt: '',
    firstName: '',
    lastName:'',
    email: '',
    phone:'',
    goal:'',
    profile:'',
  };
  userLocation = {
    city: '',
    stateProv:'',
    countryName:'',
    continentName:'',
    ipAddress:''
  };
  constructor(
    private service: WidgetService,
    private sanitizer: DomSanitizer,
    public http: HttpClient
  ) {}

  ngOnInit(): void {
    this.getResult();
    this.widgetHtml = this.sanitizer.bypassSecurityTrustHtml(
      this.calendlyWidgetHTML
    );
    this.predata = JSON.parse(localStorage.getItem("predata"));
    this.getIPLocation();
    
  }

  getResult() {
    this.service
      .getAssessmentResult({
        id: localStorage.getItem("user"),
        widgetId: WIDGET_ID,
      })
      .subscribe(
        (res) => {
          if (res && res.data) {
            this.result = res.data;
            console.log(res);
          }
        },
        (err) => {}
      );
  }

  scroll(el: HTMLElement) {
    el.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  }

  async getIPLocation() {
    let dataIP = await this.http
      .get<any>("https://api.db-ip.com/v2/free/self")
      .subscribe((res) => {
        this.userLocation = res;
        console.log("userlocation", this.userLocation);
      });
  }
}
